import { render, staticRenderFns } from "./sfrecord.vue?vue&type=template&id=6b717605&scoped=true&"
import script from "./sfrecord.vue?vue&type=script&lang=js&"
export * from "./sfrecord.vue?vue&type=script&lang=js&"
import style0 from "./sfrecord.vue?vue&type=style&index=0&id=6b717605&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b717605",
  null
  
)

export default component.exports